import React from 'react';
import SomaStatus from '../../../../components/SomaStandard/SomaStatus';
import InputsLoginForm from './InputsLoginForm/InputLoginForm';
import LogoMaisAtacado from '../../../../components/Logos/LogoMaisAtacado';
import LogoGrupoSoma from '../../../../components/Logos/LogoGrupoSoma';
import styles from './LoginForm.module.css';

const LoginForm = props => {
  const { login, senha } = props.credentials;

  return (
    <div className={styles.login}>
      <LogoMaisAtacado />
      <form className={styles.form} onSubmit={(e) => { e.preventDefault(); props.onConfirm(login, senha); }}>
        <InputsLoginForm onChange={props.onChange} login={login} senha={senha} />
        <div className={styles.passwordReset}>
          <span>Não sabe sua senha?</span>
          <span data-testid="spanForm" className={styles.clickHere} onClick={props.onForgotPassword}>Clique aqui.</span>
        </div>
        <button data-testid="buttonForm">
          <SomaStatus status={props.status === 'pending' ? 'waitComponent' : 'result'} >
            Entrar
          </SomaStatus>
        </button>
      </form>
      <LogoGrupoSoma />
    </div>
  );
};

export default LoginForm;
